export enum UserPreferenceEnum {
  inbondLayout = 'ac-auto-inbond-layout',
  redeliveryLayout = 'ac-auto-redelivery-layout',
}
